export type ChargeTimingMode =
  | "upgrade"
  | "downgrade"
  | "change-plan"
  | "resume-plan";

// Mirrors SubscriptionService.updateItems' proration rules; keep in sync, a wrong promise here is a billing-trust bug.
export function getChargeTimingCopy({
  mode,
  hasCurrentSubscription,
  isIntervalChange,
  hasChanges,
  periodTotal,
  nextBillingDate,
  percentSaved,
}: {
  mode: ChargeTimingMode;
  hasCurrentSubscription: boolean;
  isIntervalChange: boolean;
  hasChanges: boolean;
  /** Formatted price of one full billing period on the new plan, e.g. "$1,188". */
  periodTotal: string;
  /** Formatted date of the next invoice on the current subscription. */
  nextBillingDate: string;
  percentSaved: number;
}): string | null {
  const savings = percentSaved > 0 ? ` (you save ${percentSaved}%)` : "";
  if (!hasCurrentSubscription) {
    return `You'll be charged ${periodTotal} today${savings}.`;
  }
  if (mode === "resume-plan") {
    return `No charge today. Your plan renews on ${nextBillingDate}.`;
  }
  if (!hasChanges) {
    return null;
  }
  if (isIntervalChange) {
    return mode === "downgrade"
      ? `You'll be charged ${periodTotal} today. Unused time on your current plan isn't refunded.`
      : `You'll be charged ${periodTotal} today, minus credit for unused time on your current plan.`;
  }
  if (mode === "downgrade") {
    return `The lower plan and its monthly credits start now. Your new price starts on ${nextBillingDate}, and this billing period isn't refunded.`;
  }
  return `You'll be charged the difference for the rest of this billing period today, then ${periodTotal} from ${nextBillingDate}.`;
}
